export var props = {
  name: {
    type: String,
    required: true
  },
  weight: {
    type: Number,
    required: false,
    default: 1
  },
  activeBackground: {
    type: String,
    required: false
  },
  tabHeaderStyle: {
    type: Object,
    required: false
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  }
};